import { render, staticRenderFns } from "./duiZhangDialog.vue?vue&type=template&id=9c4e6b38&scoped=true&"
import script from "./duiZhangDialog.vue?vue&type=script&lang=js&"
export * from "./duiZhangDialog.vue?vue&type=script&lang=js&"
import style0 from "./duiZhangDialog.vue?vue&type=style&index=0&id=9c4e6b38&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c4e6b38",
  null
  
)

export default component.exports